export const coldEmailCampaignsArticle = {
  title: 'Cold Email Engine: Campaigns & Sequencing',
  slug: 'cold-email-campaigns',
  content: `Cold Email Engine: Campaigns & Sequencing

Use Campaigns to build multi-step outreach sequences.

1) Create a campaign
- Open Campaigns and start a new sequence.

2) Add steps
- Write the initial email and follow-ups.
- Use templates or AI assistance where available.

3) Schedule sending
- Set send windows and cadence in the campaign settings.

4) Monitor responses
- Use Inbox and Leads to track replies.
`,
};
